<div mat-dialog-title>
  <span>{{ 'POPUPS.LEGEND_ITEM_TEXT' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content>
  <form #formTemplate="ngForm" [formGroup]="form" class="legend-form">
    <q9-text-field
      formControlName="text"
      [label]="'POPUPS.LEGEND_ITEM_TEXT' | translate"
      required></q9-text-field>
    <q9-textarea-field
      formControlName="description"
      [label]="'POPUPS.LEGEND_ITEM_DESCRIPTION' | translate"
      [minRows]="3"
      [maxRows]="10"></q9-textarea-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button (click)="formTemplate.onSubmit($event); onSubmit()">
    {{ 'EDITOR.ADD_TO_LEGEND' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
